import "./index.scss";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const PasswordInput = ({
  id = "",
  name = "",
  value = "",
  className = "",
  placeholder = "",
  autoComplete = "new-password",
  onChange = () => {},
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div id="PasswordInput">
      <input
        id={id}
        name={name}
        value={value}
        type={passwordVisible ? "text" : "password"}
        onChange={onChange}
        className={className}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      <FontAwesomeIcon
        icon={passwordVisible ? faEyeSlash : faEye}
        onClick={togglePasswordVisibility}
        className="eye-icon"
      />
    </div>
  );
};

export default PasswordInput;
